import { DownloadSimple } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "~/foundation/components/Button";
import { Text } from "~/foundation/components/Text";

const FORMATS = [
  { id: "markdown", label: "Markdown", description: "One .md file per document, in a zip." },
  { id: "json", label: "JSON", description: "Structured export including metadata." },
  { id: "html", label: "HTML", description: "Rendered pages, for archiving." },
];

export function Export() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <Text variant="secondary">
        {t("Exports are generated in the background. We email you a link when it is ready.")}
      </Text>

      <ul className="flex flex-col rounded-md border border-divider">
        {FORMATS.map((format) => (
          <li
            key={format.id}
            className="flex items-center gap-3 border-b border-divider px-3 py-3 last:border-b-0"
          >
            <div className="min-w-0 flex-1">
              <p className="text-body text-text">{format.label}</p>
              <p className="text-small text-text-secondary">{t(format.description)}</p>
            </div>
            <Button
              icon={DownloadSimple}
              // SLATE-LATER (§15): kick off a real export job.
              onClick={() => toast.message(t("Export is not available yet"))}
            >
              {t("Export")}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
